import OwlFuseLogo from "../components/icons/OwlFuseLogo";

const adminUser = {
    email: "admin@owlfuse.com",
    password: "ocnsikcyseCJTa49"
}

export default adminUser;